import { useEffect, useState } from 'react';
import { toast } from 'react-hot-toast';
import { useLocation, useNavigate } from 'react-router-dom';
import { genericDelete, genericGeneratePdf, genericGet, genericPost, genericUpdate, uploadFile } from '../../../services/api.service';
import ConfigsMap from '../../ConfigsMap';
import { Box } from '@mui/material';
import { palette } from '../../../assets/theme/theme';
import EntityDisplay from './EntityDisplay';
import { BackArrow } from '../../../components/CustomMiscellaneous/BackArrow';

import { ConfigMap } from '../../..';
import Form from '../../../form';
import useForm, { useFormType } from '../../../form/hooks/useForm';
import { useMutation } from '@tanstack/react-query';
import { PropConfig } from '../../../types/EntityConfig';

const toastDuration: number = 3000;


export default function Entity({ defaultTableConfig, useAbsoluteRoute, blockEdit }: any) {


  const location = useLocation();
  const currentRoute = location.pathname;
  const routePrefix = currentRoute.split("/")[1];

  const baseRouteArray = currentRoute.split("/");
  const baseRoute = baseRouteArray.slice(0, baseRouteArray.length - 1).join('/');



  const { entityName, idProp, allowCopy, generatePdf, configMapKey, title, specificRoute }: any = location?.state ? location.state : { entityName: null, idProp: null, allowCopy: null, generatePdf: null, title: null, specificRoute: null };
  const postEntity = useAbsoluteRoute ? genericPost(baseRoute) : genericPost(specificRoute ? specificRoute : '/' + routePrefix);
  const deleteEntity = useAbsoluteRoute ? genericDelete(baseRoute) : genericDelete(specificRoute ? specificRoute : '/' + routePrefix);
  const editEntity = useAbsoluteRoute ? genericUpdate(baseRoute) : genericUpdate(specificRoute ? specificRoute : '/' + routePrefix);


  const pdfGenerator = generatePdf ? genericGeneratePdf('/' + routePrefix) : null;

  const tableConfigs: any = defaultTableConfig ? defaultTableConfig : ConfigsMap[routePrefix as keyof ConfigMap] ? ConfigsMap[routePrefix as keyof ConfigMap] : ConfigsMap[configMapKey as keyof ConfigMap];

  const navigate = useNavigate();


  const [entityData, setEntityData] = useState<any>({})


  const form: useFormType = useForm({ formConfigs: tableConfigs, initialData: entityData });

  useEffect(() => {
    console.log("Table configs updated: ", tableConfigs);
    form.reStart(tableConfigs);
  }, [tableConfigs])


  const [editable, setEditable] = useState<boolean>(false);

  const anexosMutation = useMutation(({ extension, data }: { extension: string, data: FormData }) => uploadFile({ extension, data }), {
    onSuccess: (data: any) => {
      toast.success("Anexos adicionados com sucesso!");
    },
    onError: (error) => {
      console.log("Error on upload!")
    }
  })

 



  useEffect(() => {
    genericGet(location.pathname)
      .then(d => {
        console.log("GOt data: ", d);
        setEntityData(d)
      })
  }, [location])



  useEffect(() => {
    form.set(entityData);
  }, [entityData])


  const submitData = async () => {
    const updatedData = form.state;
    await toast.promise(
      postEntity(updatedData),
      {
        success: (t: any) => (
          <span>
            <span>Entidade <b>{entityName}</b> criada com sucesso!!</span>
          </span>
        ),
        error: ({ response }: any) => (
          <span>
            <span>Erro ao criar entidade <b>{entityName}</b> <p>{response.data.error}</p></span>
          </span>
        ),
        duration: toastDuration
      } as any
    )
  }


  const deleteData = async () => {
    await toast.promise(
      deleteEntity(entityData?.id),
      {
        success: (t: any) => (
          <span>
            <span>Entidade <b>{entityName}</b> eliminada com sucesso!!</span>
          </span>
        ),
        error: ({ response }: any) => (
          <span>
            <span>Erro ao eliminar entidade <b>{entityName}</b> <p>{response.data.error}</p></span>
          </span>
        ),
        duration: toastDuration
      } as any
    )
    navigate(-1);
  }

  const patchData = async () => {

    await toast.promise(
      (async () => {
        const response = await editEntity(entityData.id, form.state);
        const camposAnexosExistentes: PropConfig[] = tableConfigs.filter((c: PropConfig) => c.type === 'anexos');
        if (camposAnexosExistentes.length > 0) {
          for (let c of camposAnexosExistentes) {
            if(!form.state[c.id]) return;
            const documentToSave = new FormData();
            form.state[c.id].map((dt: File) => {
              documentToSave.append(c.id, dt);
            })
            if (c?.options?.anexosEndpointBuildFunction) {
              anexosMutation.mutate({ extension: `${c?.options.anexosEndpointBuildFunction(response?.data)}/upload`, data: documentToSave });
            }
          }
    
        }
        setEntityData(response.data);
      })()
      ,
      {
        success: (t: any) => (
          <span>
            <span>Entidade <b>{entityName}</b> atualizada com sucesso</span>
          </span>
        ),
        error: ({ response }: any) => {
          return ((
            <span>
              <span>Erro ao editar entidade <b>{entityName}</b> <p>{response.data.error}</p></span>
            </span>
          ))
        },
        duration: toastDuration
      } as any
    )
    setEditable(false);
  }


  return (<>

    <BackArrow onClick={() => navigate(-1)} />
    {(editable) ?

      (
        <Box style={{
          marginRight: 50,
          marginLeft: 50,
        }}>
          <Form
            form={form}
            patchData={patchData}
            tableConfigs={tableConfigs}
            editable={editable}
            setEditable={setEditable}
            idProp={idProp}
            entityName={entityName}
            entityData={entityData}

          /></Box>)
      : ((form.state) ?
        <Box style={{
          marginRight: 50,
          marginLeft: 50,
        }}>
          <EntityDisplay
            form={form}
            data={entityData}
            submitData={submitData}
            deleteData={deleteData}
            allowCopy={allowCopy}
            generatePdf={pdfGenerator}
            tableConfigs={tableConfigs}
            setEditable={setEditable}
            idProp={idProp}
            entityName={entityName}
            blockEdit={blockEdit}
          />


        </Box> : null)}
  </>)

}